module.exports = __webpack_public_path__ + "img/CS26Q-中_11.d4613de9.jpg";